import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'

import type { PageEditorRowType } from './PageEditor.types'

type UsePageEditorWidgetEditingParams = {
    setRows: Dispatch<SetStateAction<PageEditorRowType[]>>
}

const usePageEditorWidgetEditing = ({
    setRows,
}: UsePageEditorWidgetEditingParams) => {
    const [widgetEditing, setWidgetEditing] = useState<any>(null)

    const closeWidgetEditing = () => {
        // If the widget was newly added, remove it again
        if (widgetEditing?.isNew) {
            const { rowIndex, columnIndex, index } = widgetEditing
            setRows((prev) =>
                prev.map((row, rIdx) =>
                    rIdx === rowIndex
                        ? {
                              ...row,
                              columns: row.columns.map((col, cIdx) =>
                                  cIdx === columnIndex
                                      ? {
                                            ...col,
                                            widgets: col.widgets.filter(
                                                (_, wIdx) => wIdx !== index,
                                            ),
                                        }
                                      : col,
                              ),
                          }
                        : row,
                ),
            )
        }
        setWidgetEditing(null)
    }

    const saveWidget = (settings: any) => {
        const { rowIndex, columnIndex, index } = widgetEditing
        setRows((prev) =>
            prev.map((row, rIdx) =>
                rIdx === rowIndex
                    ? {
                          ...row,
                          columns: row.columns.map((col, cIdx) =>
                              cIdx === columnIndex
                                  ? {
                                        ...col,
                                        widgets: col.widgets.map(
                                            (widget, wIdx) =>
                                                wIdx === index
                                                    ? { ...widget, settings }
                                                    : widget,
                                        ),
                                    }
                                  : col,
                          ),
                      }
                    : row,
            ),
        )
        setWidgetEditing(null)
    }

    return {
        widgetEditing,
        setWidgetEditing,
        closeWidgetEditing,
        saveWidget,
        isEditingWidget: !!widgetEditing,
    }
}

export default usePageEditorWidgetEditing
